function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var saito = require('./../../../lib/saito/saito');
var ControlsTemplate = require('./controls.template');
var SaitoOverlay = require('./../../../lib/saito/ui/saito-overlay/saito-overlay');
var QuakeControls = /*#__PURE__*/function () {
  function QuakeControls(app, mod, tx) {
    _classCallCheck(this, QuakeControls);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app);
    this.current_setting = '';
    //this.controls = {};
    /*****
    this.default_config = {
    '+attack': ['MOUSE1', 'bind MOUSE1 +attack'],
    '+zoom': ['MOUSE2', 'bind MOUSE2 +zoom'],
    '+forward': ['w', 'bind w +forward'],
    '+back': ['s', 'bind s +back'],
    '+moveleft': ['a', 'bind a +moveleft'],
    '+moveright': ['d', 'bind d +moveright'],
    '+moveup': ['SPACE', 'bind SPACE +moveup'],
    '+speed': ['SHIFT', 'bind SHIFT +speed'],
    '+movedown': ['CTRL', 'bind CTRL +movedown'],
    weapnext: ['MWHEELDOWN', 'bind MWHEELDOWN weapnext'],
    weapprev: ['MWHEELDOWN', 'bind MWHEELUP weapprev'],
    'weapon 1': ['1', 'bind 1 weapon 1'],
    'weapon 2': ['2', 'bind 2 weapon 2'],
    'weapon 3': ['3', 'bind 3 weapon 3'],
    'weapon 4': ['4', 'bind 4 weapon 4'],
    'weapon 5': ['5', 'bind 5 weapon 5'],
    'weapon 6': ['6', 'bind 6 weapon 6'],
    'weapon 7': ['7', 'bind 7 weapon 7'],
    'weapon 8': ['8', 'bind 8 weapon 8'],
    'weapon 9': ['9', 'bind 9 weapon 9'],
    messagemode: ['t', 'bind t messagemode'],
    messagemode2: ['y', 'bind y messagemode2'],
    '+scores': ['TAB', 'bind TAB +scores'],
    togglemenu: ['ESCAPE', 'bind ESCAPE togglemenu'],
    screenshot: ['p', 'bind p screenshot'],
    sensitivity: [5, 'sensitivity 5'],
    cg_fov: [90, 'cg_fov 90'],
    s_volume: [0.23, 's_volume 0.23']
    };
    *****/
    this.default_config = {
      '+attack': ['MOUSE1', 'bind MOUSE1 +attack'],
      '+zoom': ['MOUSE2', 'bind MOUSE2 +zoom'],
      '+forward': ['w', 'bind w +forward'],
      '+back': ['s', 'bind s +back'],
      '+moveleft': ['a', 'bind a +moveleft'],
      '+moveright': ['d', 'bind d +moveright'],
      '+moveup': ['SPACE', 'bind SPACE +moveup'],
      '+speed': ['SHIFT', 'bind SHIFT +speed'],
      '+movedown': ['CTRL', 'bind CTRL +movedown'],
      '+weapnext': ['MWHEELDOWN', 'bind MWHEELDOWN +weapnext'],
      '+weapprev': ['MWHEELUP', 'bind MWHEELUP +weapprev'],
      'weapon 1': ['1', 'bind 1 weapon 1'],
      'weapon 2': ['2', 'bind 2 weapon 2'],
      'weapon 3': ['3', 'bind 3 weapon 3'],
      'weapon 4': ['4', 'bind 4 weapon 4'],
      'weapon 5': ['5', 'bind 5 weapon 5'],
      'weapon 6': ['6', 'bind 6 weapon 6'],
      'weapon 7': ['7', 'bind 7 weapon 7'],
      'weapon 8': ['8', 'bind 8 weapon 8'],
      'weapon 9': ['9', 'bind 9 weapon 9'],
      messagemode: ['t', 'bind t messagemode'],
      messagemode2: ['y', 'bind y messagemode2'],
      '+scores': ['TAB', 'bind TAB +scores'],
      togglemenu: ['ESCAPE', 'bind ESCAPE togglemenu'],
      screenshot: ['p', 'bind p screenshot'],
      sensitivity: [5, 'sensitivity 5'],
      cg_fov: [90, 'cg_fov 90'],
      s_volume: [0.23, 's_volume 0.23']
    };
    this.controls = {};
    this.loadSavedControls();
  }
  return _createClass(QuakeControls, [{
    key: "render",
    value: function render() {
      var app = this.app;
      var mod = this.mod;
      this.overlay.show(ControlsTemplate(app, mod, this));
      this.attachEvents();
      //    this.loadSavedControls();
      // render menu with saved or default config
      this.fill_menu();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var app = this.app;
      var mod = this.mod;
      var thisobj = this;
      document.querySelectorAll('.quake-control-trigger').forEach(function (el) {
        el.onclick = function (e) {
          document.getElementById('cover-indicator').innerHTML = e.currentTarget.children[0].innerHTML;
          document.getElementById('screen-cover').style.zIndex = 100;
          var setting = e.currentTarget.getAttribute('id');
          //console.log("setting: " + setting);
          thisobj.current_setting = setting;
          thisobj.handleKey = function (e) {
            return thisobj.handleInput(e.key);
          };
          thisobj.handleMouse = function (e) {
            return thisobj.handleInput(e.button);
          };
          thisobj.handleWheel = function (e) {
            scroll = -5 * Math.sign(e.deltaY);
            return thisobj.handleInput(scroll);
          };

          // keyboard buttons
          window.addEventListener('keydown', thisobj.handleKey);
          // mouse buttons
          window.addEventListener('mousedown', thisobj.handleMouse);
          // scroll wheel
          window.addEventListener('wheel', thisobj.handleWheel);

          ////
        };
      });

      // reset defaults
      var defaultButton = document.getElementById('default-controls-button');
      defaultButton.addEventListener('click', function () {
        console.log('restore default clicked');
        thisobj.defaults();
      });
      var finishButton = document.getElementById('finish-controls-button');
      finishButton.addEventListener('click', function () {
        console.log("clicked button 'finish' button");
        _this.overlay.remove();
        _this.applyControls();
        _this.writeControls();
        _this.saveSettings();
      });

      //////////////////////////////////////////////////////////////////////////////////////////
      // slider / feild sync EVENTs

      var sens_slider = document.getElementById('sensitivity');
      var sens_indicator = document.getElementById('sensitivity_indicator');
      sens_slider.oninput = function () {
        var v = sens_slider.value;
        thisobj.updateControls(['sensitivity'], [v, 'sensitivity ' + v]);
        sens_indicator.value = v;
        thisobj.saveSettings();
      };
      sens_indicator.oninput = function () {
        var v = sens_indicator.value;
        thisobj.updateControls(['sensitivity'], [v, 'sensitivity ' + v]);
        sens_slider.value = v;
        thisobj.saveSettings();
      };
      var fov_slider = document.getElementById('cg_fov');
      var fov_indicator = document.getElementById('fov_indicator');
      fov_slider.oninput = function () {
        var v = fov_slider.value;
        thisobj.updateControls(['cg_fov'], [v, 'cg_fov ' + v]);
        fov_indicator.value = v;
        thisobj.saveSettings();
      };
      fov_indicator.oninput = function () {
        var v = fov_indicator.value;
        thisobj.updateControls(['cg_fov'], [v, 'cg_fov ' + v]);
        fov_slider.value = v;
        thisobj.saveSettings();
      };
      ///////////////////////////////////////////////////////////////////////////////////////

      // End of attachEvents() object
    }
  }, {
    key: "defaults",
    value: function defaults() {
      this.controls = structuredClone(this.default_config);
      this.fill_menu();
    }

    // useful to update this.controls from within function
  }, {
    key: "updateControls",
    value: function updateControls(key, value) {
      this.controls[key] = value;
    }

    // Apply menu controls in game
    // first write a config file, then exec console command to run file in game
  }, {
    key: "applyControls",
    value: function applyControls() {
      function type(key) {
        document.dispatchEvent(new KeyboardEvent('keydown', {
          keyCode: key
        }));
      }

      // `exec sqc` into game console
      // will fail if game console already open
      type(192); // ~
      type(191); // /
      type(69); // e
      type(88); // x
      type(69); // e
      type(67); // c
      type(32); //
      type(83); // s
      type(81); // q
      type(67); // c
      type(13); // [enter]
      type(192); // ~
    }
  }, {
    key: "writeControls",
    value: function writeControls() {
      // must be single quotes to escape implicit double quotes
      // from this.controls values
      var cfg_file = '';
      for (var _i = 0, _Object$entries = Object.entries(this.controls); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          object = _Object$entries$_i[0],
          key = _Object$entries$_i[1];
        cfg_file = cfg_file.concat(key[1] + ';');
      }
      FS.writeFile('base/baseq3/sqc.cfg', cfg_file);
    }
  }, {
    key: "loadSavedControls",
    value: function loadSavedControls() {
      this.mod.load();
      // if no saved controls
      if (!this.mod.quake3) {
        this.controls = _objectSpread({}, this.default_config);
      } else {
        this.controls = _objectSpread({}, this.mod.quake3['controls']);
      }
    }
  }, {
    key: "fill_menu",
    value: function fill_menu() {
      console.log('in fill_menu()');
      console.log(this.controls);
      for (var _i2 = 0, _Object$entries2 = Object.entries(this.controls); _i2 < _Object$entries2.length; _i2++) {
        var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
          key = _Object$entries2$_i[0],
          value = _Object$entries2$_i[1];
        var elem = document.getElementById(key);
        // for keybinds

        // DON'T ALLOW THIS TO PASS - doesn't work for some reason
        // if you actually allow this block to run
        // UI disallows key inputs to pass behind menu thus breaking applyControls()
        // only works if you just let the error ride - no idea why
        if (elem === null && false) {
          continue;
        } else if (elem.tagName == 'TR') {
          elem.children[1].innerHTML = value[0];
        }
        // for sliders
        else {
          var s_elem = document.getElementsByClassName(key);
          s_elem[0].value = value[0];
          s_elem[1].value = value[0];
        }
      }
      console.log('end of fill_menu()');
    }
  }, {
    key: "saveSettings",
    value: function saveSettings() {
      if (!this.mod.quake3) {
        this.mod.quake3 = {};
      }
      this.mod.quake3['controls'] = this.controls;
      this.mod.save();
    }
  }, {
    key: "handleInput",
    value: function handleInput(input) {
      document.getElementById('screen-cover').style.zIndex = -100;
      q3_bind = this.toQuakeBind(input);

      // remove event listeners
      window.removeEventListener('keydown', this.handleKey);
      window.removeEventListener('mousedown', this.handleMouse);
      window.removeEventListener('wheel', this.handleWheel);

      // full
      q3_bindCommand = 'bind ' + q3_bind + ' "' + this.current_setting + '"';

      // update JSON game config
      // {setting: [value, command]}
      this.controls[this.current_setting] = [q3_bind, q3_bindCommand];

      // update HTML table to reflect current settings
      // if that element exists
      var tag = document.getElementById(this.current_setting);
      if (tag != null) {
        tag.children[1].innerHTML = q3_bind;
      } else {
        console.log('tag is null: ' + this.current_setting);
      }
      this.saveSettings();
    }
  }, {
    key: "toQuakeBind",
    value: function toQuakeBind(input) {
      if (typeof input == 'number') {
        switch (input) {
          case 0:
            return 'MOUSE1';
          case 2:
            return 'MOUSE2';
          case 1:
            return 'MOUSE3';
          case 4:
            return 'MOUSE4';
          case 3:
            return 'MOUSE5';
          case 5:
            return 'MWHEELUP';
          case -5:
            return 'MWHEELDOWN';
        }
      } else if (input == ' ') {
        return 'SPACE';
      }
      // just return the key
      else if (input.length == 1) {
        return input;
      }
      // return special keys
      else if (input.length > 1) {
        switch (input) {
          case 'Shift':
            return 'SHIFT';
          case 'Control':
            return 'CTRL';
          case 'Alt':
            return 'ALT';
          case 'Backspace':
            return 'BACKSPACE';
          case 'ArrowUp':
            return 'UPARROW';
          case 'ArrowDown':
            return 'DOWNARROW';
          case 'ArrowLeft':
            return 'LEFTARROW';
          case 'ArrowRight':
            return 'RIGHTARROW';
          case 'Tab':
            return 'TAB';
          case 'Escape':
            return 'ESCAPE';
          case 'Enter':
            return 'ENTER';
          default:
            return 'bad input';
        }
      }
    }
  }]);
}();
module.exports = QuakeControls;